<div class="d-flex align-items-center gap-2 mb-0 px-1 pt-1">

  <!-- Short Logo -->
  <div class="sidebar-brand-logo mb-2 rounded-3"></div>


  <!-- Brand Title + Subtitle -->
  <div class="d-flex flex-column mt-2">
    <p class="text-white text-uppercase fw-light text-xs fw-bold mb-1">{{ title }}</p>
    <p class="text-white-50 text-uppercase fw-light text-xs">{{ subtitle }}</p>
  </div>

</div>